<template><section><h3>IEEE 2026 SciVis Contest 海洋大气气候数据可视分析系统</h3>
<p><a href="https://sciviscontest2026.github.io/">https://sciviscontest2026.github.io</a></p>
<p>本次竞赛数据为美国国家航空航天局（NASA）提供的P级海洋和大气气候数据，着重于探索气候大数据集的高级可视化方法，鼓励提出创新的解决方案，以应对诸如气候预测、天气模拟和环境影响分析等现实世界的问题。</p>
<ul>
<li>可以使用OpenVisus、Openvisuspy、Python、ParaView、以及VTK等工具进行可视化处理</li>
<li>冠军可以获得1000美刀的现金奖励</li>
</ul>
<h4>任务：</h4>
<ul>
<li>绘制从 1950 年到 2100 年可视化空气温度随时间的变化情况，探究不同地区的变化模式和差异。创建可视化图表，展示气温随时间的变化情况。探究全球不同地区湿度的变化情况。</li>
<li>利用向东（U）和向北（V）的风速来描绘全球大气风系，从而了解不同高度层的大气环流情况。</li>
<li>探究在热带风暴或飓风等极端天气事件中大气动力学与海洋之间的相互作用，关注风向、温度和洋流等方面。</li>
<li>绘制不同深度处的速度场图，来直观呈现海洋洋流的复杂三维结构，突出展示环流模式及其垂直结构。</li>
<li>生成新颖的可视化图表，这些图表能够为数据提供新的见解，且不受特定问题或任务的限制。</li>
</ul>
<h4>数据：</h4>
<table>
<thead>
<tr>
<th>Field Name</th>
<th>Data Type</th>
<th>Unit</th>
<th>Standard Name</th>
<th>Shape</th>
<th>Dimensions</th>
</tr>
</thead>
<tbody>
<tr>
<td>u</td>
<td>float32</td>
<td>m s-1</td>
<td>Sea-surface east-west velocity</td>
<td>(17280, 12960, 90)</td>
<td>Latitude, Longitude, Depth</td>
</tr>
<tr>
<td>V</td>
<td>float32</td>
<td>m s-1</td>
<td>Sea-surface north-south velocity</td>
<td>(17280, 12960, 90)</td>
<td>Latitude, Longitude, Depth</td>
</tr>
<tr>
<td>W</td>
<td>float32</td>
<td>m s-1</td>
<td>Sea-surface vertical velocity</td>
<td>(17280, 12960, 90)</td>
<td>Latitude, Longitude, Depth</td>
</tr>
<tr>
<td>theta</td>
<td>float32</td>
<td>˚C</td>
<td>Sea-surface Temperature</td>
<td>(17280, 12960, 90)</td>
<td>Latitude, Longitude, Depth</td>
</tr>
<tr>
<td>salt</td>
<td>float32</td>
<td>g kg-1</td>
<td>Sea Water Salinity</td>
<td>(17280, 12960, 90)</td>
<td>Latitude, Longitude, Depth</td>
</tr>
</tbody>
</table>
</section></template><script>export default {components:{}}</script>